import authService from "../features/auth/services/authService";
import {
  API_VERSION,
  API_BASE_PATH,
  API_ENDPOINTS,
  buildApiPath,
  getApiUrl,
} from "../shared/utils/apiConfig";

export { API_VERSION, API_BASE_PATH, API_ENDPOINTS, buildApiPath, getApiUrl };

export const getWebSocketUrl = (version = "v1") => {
  const apiUrl = getApiUrl();
  const wsPath =
    version === "v2"
      ? `/api/v2${API_ENDPOINTS.WS}`
      : buildApiPath(API_ENDPOINTS.WS);

  // Properly handle https -> wss and http -> ws conversion
  const u = new URL(apiUrl);
  u.protocol = u.protocol === "https:" ? "wss:" : "ws:";
  const wsUrl = `${u.origin}${wsPath}`;

  // Add auth token to WebSocket URL if available
  const token = authService.getAccessToken();
  if (token) {
    const separator = wsUrl.includes("?") ? "&" : "?";
    return `${wsUrl}${separator}token=${encodeURIComponent(token)}`;
  }

  return wsUrl;
};

// Get authenticated axios instance
export const getAuthenticatedAxios = () => {
  return authService.getAxios();
};
